import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgBuilding4 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="m11.919 1.186-7 5A1 1 0 0 0 4.5 7v15a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1.581-.814ZM11.5 3.942V21h-5V7.514l5-3.572Z" />
      <path d="M11.686 5.919a1 1 0 0 1 1.289-.3l.106.067 7 5a1 1 0 0 1 .412.694l.007.12V22a1 1 0 0 1-1.993.117L18.5 22v-9.986l-6.581-4.7a1 1 0 0 1-.3-1.289l.067-.106Z" />
      <path d="M22 21a1 1 0 0 1 .117 1.993L22 23H2a1 1 0 0 1-.117-1.993L2 21h20Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgBuilding4)
const Memo = memo(ForwardRef)
export default Memo
